import { View } from "@/components/ui";
import { cn } from "@/lib/utils";

import { FormControlError } from "../form-control-error";
import { Typography } from "../typography";
import { InputPhoneNumberContent } from "./input-phone-number-content";
import type { InputPhoneNumberProps } from "./types";

export type { InputPhoneNumberProps };

export const InputPhoneNumber = ({
  className,
  inputClassName,
  label,
  error,
  value,
  onChange,
  disabled,
}: InputPhoneNumberProps) => {
  return (
    <View className={cn("flex flex-col gap-1", className)}>
      {label && (
        <Typography variant="label-sm" color={"foreground-default"}>
          {label}
        </Typography>
      )}
      <InputPhoneNumberContent
        value={value}
        onChange={onChange}
        inputClassName={inputClassName}
        error={error}
        disabled={disabled}
      />
      {error && <FormControlError error={error} />}
    </View>
  );
};
